import { useTheme } from '@vitvio/design-system';
import { IndicatorPendingIcon, IndicatorIcon, IndicatorCompletedIcon } from '@vitvio/shared-components';

interface Props {
  status: string;
}
export function TimerContentIndicatorIcon({ status }: Props) {
  const { getColor } = useTheme();

  switch (status) {
    case 'SCHEDULED':
      return <IndicatorPendingIcon boxSize={10} color={getColor('fg.muted')} />;
    case 'RUNNING':
      return <IndicatorIcon boxSize={10} color={getColor('fg.muted')} />;
    case 'COMPLETED':
      return <IndicatorCompletedIcon boxSize={10} />;
    default:
      return <IndicatorPendingIcon boxSize={10} color={getColor('fg.muted')} />;
  }
}
